var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.98 10.333L13.65 10.333 13.65 7 10.321 7 10.321 10.333 6.992 10.333 6.992 13.667 10.321 13.667 10.321 17 13.65 17 13.65 13.667 16.98 13.667z",
    transform: "translate(-176 -545) translate(162 531) translate(14.015 14) translate(.5 2)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.472 5.625c0-1.17-.898-2.125-1.998-2.125H2.497C1.398 3.5.499 4.455.499 5.625v12.75c0 1.169.9 2.125 1.998 2.125h18.977c1.1 0 1.998-.956 1.998-2.125V5.625zM7.99 3V1.5c0-.825.77-1.5 1.713-1.5h4.566c.941 0 1.712.675 1.712 1.5V3",
    transform: "translate(-176 -545) translate(162 531) translate(14.015 14) translate(.5 2)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.f6c49601.svg";
export { ForwardRef as ReactComponent };